import { render, staticRenderFns } from "./CategoryDemandAllBuyers.vue?vue&type=template&id=4eb8c521&scoped=true"
import script from "./CategoryDemandAllBuyers.vue?vue&type=script&lang=js"
export * from "./CategoryDemandAllBuyers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb8c521",
  null
  
)

export default component.exports